<template>
    <v-container grid-list-sm text-xs-left mt-4>
        <v-layout row wrap justify-left fill-height>
            <v-flex xs12>
                <!--<v-flex xs12>
                    <font size="7">
                        Try it out
                    </font>
                </v-flex>-->
                <v-tabs
                        v-model="selectedStartupTab"
                        color="transparent"
                        slider-color="primary"
                        centered
                >
                    <v-tab
                            v-for="startupsTab in startupsTabs"
                            :key="startupsTab.id"
                            ripple
                    >
                        <strong>{{ startupsTab.name }}</strong>
                    </v-tab>
                    <v-tab-item
                            :key="startupsTabs[0].id"
                            class="my-2"
                    >
                        <ApprovedStartupList/>
                    </v-tab-item>
                    <v-tab-item
                            :key="startupsTabs[1].id"
                            class="my-2"
                    >
                        <ToBeConfirmedStartupList/>

                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import ApprovedStartupList from "@/pages/Admin/Innovation/StartupManagement/ApprovedStartupList";
    import ToBeConfirmedStartupList from "@/pages/Admin/Innovation/StartupManagement/ToBeConfirmedStartupList";

    export default {
        name: "StartupManagement",
        components: {
            ApprovedStartupList,
            ToBeConfirmedStartupList,
        },
        data() {
            return {
                startupsTabs: [
                    {
                        id: 1,
                        name: "Approved",
                        path: "/iadmin/startupManagement/list",
                    },
                    {
                        id: 2,
                        name: "To be confirmed",
                        path: "/iadmin/startupManagement/toBeConfirmedList",
                    },

                ],
                selectedStartupTab: "Approved",
            };
        },
        methods: {

        },
    };
</script>

<style lang="scss" scoped>
    .v-window__container,
    .v-window-item  {
        height: 100%;
    }
</style>
